import { render, staticRenderFns } from "./style-five.vue?vue&type=template&id=6c04f89c&scoped=true&"
import script from "./style-five.vue?vue&type=script&lang=js&"
export * from "./style-five.vue?vue&type=script&lang=js&"
import style0 from "./style-five.vue?vue&type=style&index=0&id=6c04f89c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c04f89c",
  null
  
)

export default component.exports